import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@material-ui/core'

import { BulkActionResultDialog } from 'components'

import constants from 'constants/index'

const ImportDepartmentsSummaryDialog = ({ open, setOpen, summary }) => {
  const { IMPORT_SKIPPED_REASONS, IMPORT_BLANK_NAME_LABEL } =
    constants.departments

  const theme = useTheme()

  const rowErrors = summary?.errors ?? []

  const buildItem = (rowError) => ({
    id: rowError.line,
    name: rowError.name || IMPORT_BLANK_NAME_LABEL,
    subtitle: `Linha ${rowError.line}`,
    detail: rowError.message,
  })

  const skipped = rowErrors
    .filter((rowError) => IMPORT_SKIPPED_REASONS.includes(rowError.reason))
    .map(buildItem)

  const failed = rowErrors
    .filter((rowError) => !IMPORT_SKIPPED_REASONS.includes(rowError.reason))
    .map(buildItem)

  return (
    <BulkActionResultDialog
      open={open}
      setOpen={setOpen}
      title="Resultado da importação"
      succeededCount={summary?.imported ?? 0}
      skipped={skipped}
      failed={failed}
      accentColor={theme.palette.layout.main}
    />
  )
}

ImportDepartmentsSummaryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  summary: PropTypes.object,
}

export default ImportDepartmentsSummaryDialog
